<template>
  <div class="app-container">
    <el-form :model="form" :rules="rules" ref="form" label-width="220px">
      <el-form-item label="藏品" prop="product_id">
        <el-select
            v-model="form.product_id"
            placeholder="请选择藏品"
            clearable
            style="width: 200px; margin-top: 5px"
            @change="test"
            class="filter-item"
            filterable
        >
          <el-option
              v-for="(item, key) in products"
              :key="key"
              :label="item.no + '(' + item.name + ')'"
              :value="item.id"
          />
        </el-select>
      </el-form-item>



      <el-form-item label="快照时间" prop="snap_at">
        <el-date-picker
            v-model="form.snap_at"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            default-time="12:00:00"
        >
        </el-date-picker>
        <!--        <el-date-picker-->
        <!--          v-model="date"-->
        <!--          type="date"-->
        <!--          placeholder="选择日期时间"-->
        <!--          value-format="yyyy-MM-dd"-->
        <!--        >-->
        <!--        </el-date-picker>-->

        <!--        <el-time-picker-->
        <!--          v-model="time"-->
        <!--          placeholder="选择时间点"-->
        <!--          value-format="HH:mm:ss"-->
        <!--        >
                </el-time-picker>-->
      </el-form-item>
      <el-form-item label="" prop="snap_at">
        <el-checkbox v-model="checked">统计数量</el-checkbox>
      </el-form-item>
      <el-form-item>
        <!--        <el-button @click="$router.go(-1)">返回</el-button>-->
        <download-excel
            :fields="json_fields"
            :fetch="handleExport"
            type="xls"
            name="快照信息.xls"
            worksheet="快照信息"
            style="width: 7%"
        >
          <el-button type="warning" :loading="exportLoading">
            导出信息
          </el-button>
        </download-excel>
      </el-form-item>
    </el-form>


  </div>
</template>
<script>
import Tinymce from "@/components/Tinymce";
import UploadList from "@/components/UploadList/index.vue";
import productAPI from "@/api/product";
import downloadExcel from "vue-json-excel";
import request from "@/utils/request";
// import { descartes } from "@/utils/tool";
export default {
  components: {
    Tinymce,
    UploadList,
    downloadExcel
  },
  data() {
    return {
      disabled: false,
      products:[],
      product_id: '',
      btnLoading: false,
      checked:false,
      exportLoading:false,
      date: '',
      time:'',
      form: {
      },
      //导出
      json_fields: {

      },
      rules: {
        product: [
          { required: true, message: "藏品不能为空", trigger: "change" },
        ],
        //  snap_at: [{ required: true, message: "快照时间不能为空", trigger: "blur" }],
      },
      typelist: [],
      inputValue: "",
      sType: null,
      inputVisible: false,
      // listQuery: {
      //   page: 1,
      //   limit: 10,
      //   title: "",
      //   is_on: "",
      //   is_index_show: "",
      //   category: "",
      // },
    };
  },
  created() {
    this.getProduct();

  },
  mounted() {
    this.getTodayValue();
  },
  methods: {
    initJson(val) {
      if (val === 0) {
        this.json_fields = {
          手机号码: {
            field: "account",
            //自定义回调函数
            callback: (value) => {
              return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
            },
          },
          藏品编号: "no",
          藏品名称: "name",
        }
      }else {
        this.json_fields = {
          手机号码: {
            field: "account",
            //自定义回调函数
            callback: (value) => {
              return "<p style=\"mso-number-format:'\\@';\">" + value + "</p>";
            },
          },
          藏品编号: "no",
          藏品名称: "name",
          拥有数量: "uid_count",
        }
      }

    },
    getProduct() {
      productAPI.getProductName().then(res => {
        if (res.code === 0) {
          this.products = res.data;
        }
      })
    },
    test(val){
      console.log(this.form.product_id);
    },

    handleExport(){
      if (!this.form.snap_at) {
        this.$message.error('请选择快照时间');
        return
      }
      if (!this.form.product_id) {
        this.$message.error('请选择藏品时间');
        return
      }
      this.exportLoading = true;
      if (this.checked === false) {
        this.form.is_statistics = 0;
      }else {
        this.form.is_statistics = 1;
      }
      // this.form.snap_at = this.date + " " + this.time
      this.initJson(this.form.is_statistics);
      console.log(this.form);
      return productAPI.getSnapData(this.form).then((result) => {
        var json_data = result.data;
        this.header = "快照信息";
        console.log(json_data);
        return json_data;
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.listLoading = false;
        this.exportLoading = false;
      });
      // this.$refs["form"].validate((valid) => {
      //   if (valid) {
      //
      //   }
      // });
    },

    handleClose(e) {
      this.form.product_specs.splice(e, 1);
      this.setSKU();
    },
    selectType(e) {
      console.log(e);
      this.sType = e;
      this.form.product_id = e;
      this.$forceUpdate(); //强制更新
    },
    getTodayValue() {
      var now = new Date()
      var year = now.getFullYear() // 得到年份
      var month = now.getMonth() // 得到月份
      var date = now.getDate() // 得到日期
      var hours = now.getHours()
      var getMinutes = now.getMinutes()
      var getSeconds = now.getSeconds()
      var defaultDate = `${year}-${month}-${date}`
      this.date = defaultDate;
      // this.form.snap_at = new Date().getFullYear() + "-" + new Date().getMonth() + "-" + new Date().getDate() + " 00:00:00";
    },

    saveData() {


    },
  },
};
</script>
<style lang="scss" scoped>
.el-input {
  width: 300px;
}
.input-new-tag {
  width: 150px;
}
</style>